module.exports = "<div id=\"category-filter\" class=\"aside__filters v11\">\r\n  <div class=\"widget__products widget-aside v11\">\r\n    <h6 class=\"widget-aside__title\">Líneas de Productos</h6>\r\n    <div class=\"widget-aside__wrapper widget__accordion\">\r\n      <categories-accordion items=\"$ctrl.shCtrl.globalCategoriesMenu[0].hijas\"></categories-accordion>\r\n    </div>\r\n  </div>\r\n</div>\r\n";


/*****************
 ** WEBPACK FOOTER
 ** ./www/components/catalog/categories-filter/categories-slider-filter/templates/categories-slider-filter-t11.view.html
 ** module id = 427
 ** module chunks = 0
 **/